import { useContext, useEffect, useState } from "react";
import { RootContext } from "../../../stores";
import { IProfileSelectionFormValues } from "../../authentication/_interfaces/IProfileSelectionFormValues";
import { AppError } from "../../../stores/models/errors/AppError";

export function useProfilesSelectorController(
    // values: IProfileSelectionFormValues,
    // // allValues: IAdminInvitationFlowValues,
    // update: (patch: Partial<IProfileSelectionFormValues>) => void,
    // onSuccess: (override?: Partial<IProfileSelectionFormValues>) => void
) {
    const rootStore = useContext(RootContext);
    const userStore = rootStore.userStore;

    const [values, setValues] = useState<IProfileSelectionFormValues>({} as IProfileSelectionFormValues);
    const [error, setError] = useState<string>();
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof IProfileSelectionFormValues, string>>>({});
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    const update = (patch: Partial<any>) => {
        setValues((v) => ({ ...v, ...patch }));
        submit(patch);
    };

    useEffect(() => {
        const profiles = userStore.user.profileData;
        const defaultProfile = profiles?.find(profile => profile.default);
        const activeProfile = profiles?.find(profile => profile.active);
        if (profiles !== undefined && defaultProfile && activeProfile) {
            setValues({ profiles, defaultProfileId: defaultProfile.id, activeProfileId: activeProfile.id });
            setIsLoading(false);
        }
    }, [userStore.user.id, userStore.user.profileData]);

    const submit = async (submission?: Partial<IProfileSelectionFormValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);

        try {
            if (submission !== undefined) {

                if ('defaultProfileId' in submission && submission.defaultProfileId !== undefined) {
                    const result = await rootStore.userStore.updateUserProfileStatus(userStore.user.id, submission.defaultProfileId, 'default');
                    // onSuccess(updatedOverride);
                } else if ('activeProfileId' in submission && submission.activeProfileId !== undefined) {
                    const result = await rootStore.userStore.updateUserProfileStatus(userStore.user.id, submission.activeProfileId, 'active');
                }
            }
        } catch (err) {
            //     if (err instanceof AppError) {
            //         setError(err.message);
            //     } else {
            //         setError("An unknown error occurred.");
            //     }
        } finally {
            setSubmitting(false);
        }
    };

    return {
        values: { ...values, isLoading },
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
        fieldErrors
    };
}
